module.exports = __webpack_public_path__ + "static/media/scanner.8132460d.svg";